import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import { useParams } from "react-router-dom";
import { RichText } from "@payloadcms/richtext-lexical/react";
import Breadcrumb from "./Breadcrumb";
import BlogArea from "./related-blogs";

function Blogarea() {
  const { id } = useParams();


 const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Obigin Games",
          text: "Check out this blog post!",
          url: window.location.href,
        });
        console.log("Shared successfully!");
      } catch (err) {
        console.error("Share failed:", err);
      }
    } else {
      alert("Sharing not supported in this browser.");
    }
  };


  const {
    data: blog,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["blog-details", id],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://be-staging.obigin.com/content/blogs/${id}`
      );
      return data.data;
    },
    enabled: !!id,
  });

  if (isLoading) return <p>Loading...</p>;
  if (isError || !blog) return <p>Error loading blog</p>;

  return (
    <>
      <Breadcrumb title={blog.title} slug={blog.slug} />
      <section className="blog-area primary-bg pt-120 pb-175">
        <div className="container container-center ">
          <div className=" container-center">
            <div className="col-lg-8">
              <div className="blog-list-post">
                <div className="blog-list-post-thumb">
                  <img
                    src={blog.coverImage}
                    alt={blog.title}
                    style={{ width: "100%", height: "auto" }}
                  />
                </div>
                <div className="blog-list-post-content">
                  <div className="blog-list-post-tag mb-25">
                    <span>{blog.category || "Uncategorized"}</span>
                  </div>
                  <h2>{blog.title}</h2>
                  <div className="blog-meta">
                    <ul>
                      <li>
                        by <a href="/#">{blog.author}</a>{" "}
                        {new Date(blog.createdAt).toLocaleDateString()}
                      </li>
                    </ul>
                  </div>
                  <RichText data={blog.content} />
                </div>
                <div className="blog-list-post-bottom">
                  <ul>
                    <li>
                      {/* <a href="/#">
                        Share Post <i className="fas fa-angle-double-right" />
                      </a> */}
                      <div role="button" style={{
                        cursor:"pointer"
                      }} onClick={handleShare} className="bg-transparent outline-none text-red cursor-pointer" >
                        <span className="mr-2" > Share Post </span> <i className="fas fa-angle-double-right" />
                   </div>
                    </li>
                    {/* <li>
                    <span>SHARE :</span>
                    <div className="blog-post-share">
                      <a href="/#">
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a href="/#">
                        <i className="fab fa-twitter" />
                      </a>
                      <a href="/#">
                        <i className="fab fa-pinterest-p" />
                      </a>
                    </div>
                  </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BlogArea/>
      </section>
    </>
  );
}

export default Blogarea;
